/* Plain sort control on collection pages.

   With filtering switched off, Dawn's mobile "Sort" button still opened its
   full-screen filter drawer -- a near-empty white panel with Remove all and
   Apply at the bottom, for the sake of one dropdown. This replaces it with a
   native <select>, so tapping Sort opens the phone's own picker right there.

   Dawn's own controls are hidden rather than removed, and the options are
   copied from them, so if the theme's sort list changes this follows it. */
(function(){
  'use strict';

  var CSS=[
    '.cb-sortbar{display:flex;align-items:center;gap:10px;padding:2px 0 6px;flex-wrap:wrap}',
    '.cb-sortlbl{flex:none;font-size:13px;font-weight:600;letter-spacing:.02em;color:rgba(var(--color-foreground),.62)}',
    '.cb-sortsel{flex:1;min-width:180px;max-width:300px;height:44px;border-radius:10px;',
    'border:1px solid rgba(var(--color-foreground),.2);background:rgb(var(--color-background));',
    'color:rgb(var(--color-foreground));font-size:15px;font-weight:500;padding:0 12px;cursor:pointer}',
    '.cb-sortsel:focus{outline:2px solid rgba(var(--color-foreground),.45);outline-offset:1px}',
    '.facets-container .mobile-facets__wrapper{display:none!important}',
    '.facets-container .facets__form{display:none!important}',
    '.facets-container facet-filters-form form.facets__form{display:none!important}',
    '.facets-container .facets__wrapper{display:none!important}'
  ].join('');

  function injectCss(){
    if(document.getElementById('cb-sort-css'))return;
    var s=document.createElement('style');
    s.id='cb-sort-css';
    s.textContent=CSS;
    document.head.appendChild(s);
  }

  function setup(){
    var container=document.querySelector('.facets-container');
    if(!container||container.dataset.cbSort)return;

    var src=document.getElementById('SortBy')||document.getElementById('SortBy-mobile');
    if(!src||!src.options||!src.options.length)return;

    container.dataset.cbSort='1';
    injectCss();

    var bar=document.createElement('div');
    bar.className='cb-sortbar';

    var lbl=document.createElement('span');
    lbl.className='cb-sortlbl';
    lbl.textContent='Sort by';

    var sel=document.createElement('select');
    sel.className='cb-sortsel';
    sel.setAttribute('aria-label','Sort products by');

    for(var i=0;i<src.options.length;i++){
      var o=document.createElement('option');
      o.value=src.options[i].value;
      o.textContent=src.options[i].text;
      sel.appendChild(o);
    }
    sel.value=src.value;

    bar.appendChild(lbl);
    bar.appendChild(sel);
    container.insertBefore(bar,container.firstChild);

    sel.addEventListener('change',function(){
      var u;
      try{ u=new URL(window.location.href); }
      catch(e){ return; }
      u.searchParams.set('sort_by',sel.value);
      u.searchParams.delete('page');
      window.location.href=u.toString();
    });
  }

  function boot(){ try{ setup(); }catch(e){} }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
  setTimeout(boot,900);
})();
